import { useState } from 'react';

import { Box, capitalize, Collapse, Typography, useTheme } from '@mui/material';
import { useMediaQuery } from '@mui/system';
import { Outlet } from 'react-router-dom';

import MainHeader from './headers/header';
import SideMenu from './navigation/sideMenu/sideMenu';

const MainLayout = () => {
	const [sideMenuOpen, setSideMenuOpen] = useState(true);
	const env = import.meta.env.VITE_APP_ENV;
	const isProduction = env === 'production';

	const theme = useTheme();
	const forceMenuOpen = useMediaQuery(theme.breakpoints.up('lg'));
	const envBarHeight = isProduction ? '0px' : '24px';
	let envBarColor = theme.palette.bgInfoSecondary.main;
	switch (env) {
		case 'development':
			envBarColor = theme.palette.bgInfoSecondary.main;
			break;
		case 'test':
			envBarColor = theme.palette.bgInfoSecondary.main;
			break;
		case 'accept':
			envBarColor = theme.palette.bgSuccessSecondary.main;
			break;
	}

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				width: 1,
				height: '100dvh',
			}}
		>
			{!isProduction && (
				<Box
					sx={{
						position: 'absolute',
						width: '100%',
						height: envBarHeight,
						textAlign: 'center',
						backgroundColor: envBarColor,
						zIndex: 500,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<Typography variant='labelSm' color={theme.palette.textPrimary.main}>
						{capitalize(env)} Environment
					</Typography>
				</Box>
			)}
			<Box
				sx={{
					display: 'flex',
					flexShrink: 1,
					flexDirection: 'column',
					minHeight: 0,
					// Sit below the (conditional) environment bar and take exactly the
					// remaining height — `envBarHeight` is '0px' in production.
					mt: envBarHeight,
					height: `calc(100% - ${envBarHeight})`,
					borderRight: 1,
					borderColor: theme.palette.borderTertiary.main,
				}}
			>
				<Collapse
					orientation='horizontal'
					in={sideMenuOpen || forceMenuOpen}
					sx={{
						// Fill the wrapper's height via flex (no percentage-height chain,
						// which MUI's horizontal Collapse breaks by forcing height:auto).
						display: 'flex',
						flexDirection: 'column',
						flex: 1,
						minHeight: 0,
						'& .MuiCollapse-wrapper': {
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							minHeight: 0,
							width: 'auto',
						},
						'& .MuiCollapse-wrapperInner': {
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							minHeight: 0,
							width: 'auto',
						},
					}}
				>
					<SideMenu />
				</Collapse>
			</Box>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					flex: '1',
					overflow: 'hidden',
					pt: envBarHeight,
				}}
			>
				<MainHeader
					menuOpen={sideMenuOpen}
					onMenuToggleClick={() => setSideMenuOpen((prev) => !prev)}
				/>
				<Box
					sx={{
						display: 'block',
						flex: '1',
						overflowY: 'auto',
						backgroundColor: theme.palette.bgSecondary.main,
					}}
				>
					<Outlet />
				</Box>
			</Box>
		</Box>
	);
};

export default MainLayout;
